import template from './users-update.html';
import controller from './users-update.controller';
import './users-update.styl';

const usersUpdateComponent = {
  template,
  controller,
  controllerAs: 'usersUpdate',
  bindings: {
    resolve: '<',
    close: '&',
    dismiss: '&'
  }
};

export default usersUpdateComponent;


/** WEBPACK FOOTER **
 ** ./frontend/components/admin/users/users-update/users-update.component.js
 **/